import { FC } from 'react'

import {
  modalAnimationDuration,
  navModalBodyOpenClassName,
  navModalPortalClassName,
} from '../../../brunswick/styles/constants'
import { navModalStyles } from '../../../brunswick/styles/shared'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../modals/NextModal'
import { NavModalContent } from '../NavModalContent'

import { HiddenCrawlableNavigationContent } from './styles'

export const NavModal: FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  return (
    <>
      {!isOpen && (
        <HiddenCrawlableNavigationContent>
          <NavModalContent closeModal={onClose} renderAllNavigationTabs />
        </HiddenCrawlableNavigationContent>
      )}

      <NextModal
        shouldReturnFocusAfterClose={true}
        isOpen={isOpen}
        bodyOpenClassName={navModalBodyOpenClassName}
        closeTimeoutMS={modalAnimationDuration}
        onRequestClose={onClose}
        portalClassName={navModalPortalClassName}
        style={navModalStyles}
        closeOnSearchParamChange
      >
        <NavModalContent closeModal={onClose} />
      </NextModal>
    </>
  )
}
